import { cn } from "@/util/cn";
import { Button } from "./Button";
import { ArrowLeft } from "lucide-react";

type BackButtonProps = {
  handleBack: () => void;
  className?: string;
  disabled?: boolean;
  buttonClassName?: string;
  label?: string;
};

export default function BackButton({
  handleBack,
  className,
  disabled,
  buttonClassName,
  label = "Back",
}: BackButtonProps) {
  return (
    <div className={cn("flex items-center", className)}>
      <Button
        type="button"
        variant="ghost"
        onClick={handleBack}
        disabled={disabled}
        className={buttonClassName}
      >
        <ArrowLeft />
        <span className="hidden sm:inline">{label}</span>
      </Button>
    </div>
  );
}
